import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import ResizableImageComponent from './ResizableImageComponent';

const ResizableImage = Node.create({
  name: 'resizableImage',
  group: 'inline',
  inline: true,
  draggable: true,
  selectable: true,
  // atom: true, // 필요하다면 제거

  addAttributes() {
    return {
      src: { default: null },
      alt: { default: null },
      width: { default: null },   // 'auto' 대신 null
      height: { default: null },  // 'auto' 대신 null
    };
  },

  parseHTML() {
    return [
      { tag: 'img[src]' },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    // width/height가 null일 경우 속성 제거
    const attrs = { ...HTMLAttributes };
    if (attrs.width === null) delete attrs.width;
    if (attrs.height === null) delete attrs.height;

    return ['img', mergeAttributes(attrs)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(ResizableImageComponent);
  },
});

export default ResizableImage;